module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-2-260185736c9fdef4e117cf2911bcd1c2.webp";